<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row class="ma-0 pa-0">
      <v-col v-for="category in categories"
             :key="category.name"
             cols="12"
             md="3" v-ripple
             class="ma-0 pa-0 category-box"
             :class="{'img-hover-zoom': $vuetify.breakpoint.mdAndUp}"
             @click="$router.push(`/gallery/${category.name}`)"
      >
        <div class="category-title">
          {{category.title}}
        </div>

          <v-img :src="category.thumbnail" class="image"
                 :height="$vuetify.breakpoint.smAndDown ? '20vh' : '95vh'"
          >
          </v-img>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Gallery",
  data() {
    return {
      categories: [
        {
          title: "Decorazioni interni",
          name: "decori-interni",
          thumbnail: require("@/assets/decori_interni.jpg")
        },
        {
          title: "Decorazioni esterni",
          name: "decori-esterni",
          thumbnail: require("@/assets/decori_esterni.jpg")
        },
        {
          title: "Restauri esterni",
          name: "restauri-esterni",
          thumbnail: require("@/assets/restauri_esterni.jpg")
        },
        {
          title: "Restauri interni",
          name: "restauri-interni",
          thumbnail: require("@/assets/restauri_interni.jpg")
        }
      ]
    }
  },

  // methods: {
  //   selectCategory(selected) {
  //     this.selected = selected
  //     this.categoryName = name
  //     window.scrollTo(0,0)
  //   }
  // }
}
</script>

<style scoped lang="scss">
.image {
  transition: opacity .4s ease-in-out;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* [1] The container */
.img-hover-zoom {
  overflow: hidden; /* [1.2] Hide the overflowing of child elements */
}

/* [2] Transition property for smooth transformation of images */
.img-hover-zoom .image {
  transition: transform 1s ease, filter .5s ease-in-out;
  filter: grayscale(100%);
}

/* [3] Finally, transforming the image when container gets hovered */
.img-hover-zoom:hover .image {
  transform: scale(1.3);
  filter: grayscale(0);
}

.category-title {
  background-color: rgba(255, 255, 255, 0.9);
  color: black;
  text-align: center;
  position: relative;
  font-family: 'Patrick Hand', cursive;
  font-size: 2.2rem;
  z-index: 1;

}

.category-box {
  border: 1px solid black;
  cursor: pointer;
}

</style>